<svelte:options customElement="clw-icon-play" />

<script lang="ts">
    let className = '';
    export { className as class };
</script>

<svg width="100%" height="100%" viewBox="0 0 61 62" fill="none" xmlns="http://www.w3.org/2000/svg" class={className}>
    <path
        d="M30.6409 1.5577C14.4629 1.5577 1.31771 14.7029 1.31771 30.8809C1.31771 47.0589 14.4629 60.2041 30.6409 60.2041C46.8189 60.2041 59.9641 47.0589 59.9641 30.8809C59.9641 14.7029 46.8189 1.5577 30.6409 1.5577ZM30.6409 6.0315C44.3812 6.0315 55.49 17.1402 55.49 30.8806C55.49 44.621 44.3818 55.7298 30.6409 55.7298C16.9006 55.7298 5.79176 44.621 5.79176 30.8806C5.79176 17.1402 16.9 6.0315 30.6409 6.0315ZM23.6511 17.6148C22.9194 17.1757 21.9885 17.7028 21.9885 18.5562V43.2051C21.9885 44.0584 22.9194 44.5855 23.6511 44.1465L44.1919 31.822C44.9026 31.3956 44.9026 30.3656 44.1919 29.9392L23.6511 17.6148Z"
        fill="inherit"
        stroke="inherit"
        stroke-width="1.62288"
    />
</svg>
